<template>
    <div class="min-h-screen bg-slate-50">
        <NuxtPwaManifest />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>
